export class UserListDTO {
    
    id: string;
    
    firstName: string;
    
    lastName: string;

    email: string;

    image: string;

}
